import React from "react";
import dayjs from "dayjs";
import { DefaultDateFormat, TextLightColor } from "./StringConstants";

export const renderNullableText = (t?: string) => t ?? <span style={{ color: TextLightColor }}>Нет данных</span>;
export const renderNullableDate = (d?: string) => (d ? dayjs(d).format(DefaultDateFormat) : renderNullableText());
